enum DomesticPaymentTransactionStatus {
  ACSC = 'ACSC',
  NAUT = 'NAUT',
  PDNG = 'PDNG',
  RJCT = 'RJCT',
}

export default DomesticPaymentTransactionStatus;
